import React from "react";
import { bool, string, func, object } from "prop-types";
import get from "lodash/get";

import { Icon } from "../../atoms/icon";
import "./communication-preferences-modal.m.css";
import { COMMUNICATION_PREFERENCES_MODAL_CONTENT } from "../../../constants";

export const CommunicationPreferencesModal = ({
  isOpen,
  onClose,
  selectedPreference,
  subscriberMetadata,
  className = "",
  ...props
}) => {
  if (!isOpen) return null;

  const preferenceText = COMMUNICATION_PREFERENCES_MODAL_CONTENT.PREFERENCE_LABELS[selectedPreference] || selectedPreference;

  const {
    'client-manager': managerName = '',
    'client-manager-email': managerEmail = '',
    'client-manager-mobile': managerPhone = ''
  } = subscriberMetadata || {};

  return (
    <div styleName="modal-overlay" className={className} {...props}>
      <div styleName="modal-content">
        <button styleName="close-button" onClick={onClose} type="button">
          <Icon name="close" size="xsmall" />
        </button>

        <div styleName="modal-header">
          <h2 styleName="modal-title">{COMMUNICATION_PREFERENCES_MODAL_CONTENT.MODAL_TITLE}</h2>
        </div>

        <div styleName="modal-body">
          <p styleName="confirmation-text">
            {COMMUNICATION_PREFERENCES_MODAL_CONTENT.CONFIRMATION_TEXT}
            <br />
            <span styleName="preference-highlight">‘{preferenceText}’</span>
          </p>

          <div styleName="manager-info-section">
            <p styleName="manager-note">
              {COMMUNICATION_PREFERENCES_MODAL_CONTENT.MANAGER_NOTE}
            </p>

            <div styleName="manager-details">
              <span styleName="manager-name">{managerName}</span>
              <div styleName="manager-separator"></div>
              <span styleName="manager-email">{managerEmail}</span>
              <div styleName="manager-separator"></div>
              <span styleName="manager-phone">{managerPhone}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CommunicationPreferencesModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  selectedPreference: string,
  subscriberMetadata: object,
  className: string
};